<div class="booble-backdrop-drawer-right">
  <div class="drawer-rtl-in">
    <div class="drawer-content-lg">
      <div class="row padding-left-32 drawer-header">
        <div class="col-md-11">
          <div class="d-flex flex-column">
            <h2 class="title-modal">Avaliação da ordem</h2>
            <p class="p-text-grey-scale-dark mg-bottom-24">
              Confira as informações da ordem para aprovação ou recusa.
            </p>
          </div>
        </div>

        <div class="col-md-1 d-flex justify-content-end mg-top-10">
          <div (click)="closeModal()" class="close-icon tappable">
            <img src="assets/image/close-modal-icon.svg" />
          </div>
        </div>
      </div>
      <div class="modal-dialog-scrollable-general">
        <div class="modal-body h-100">
          <div class="box-order">
            <app-order-data
              [boobleModalData]="boobleModalData"
              [rType]="rType"
              [currency]="currency"
              [showDocuments]="true"
            ></app-order-data>
          </div>

          <div
            *ngIf="boobleModalData?.orderAttachments?.length > 0"
            class="div-documents"
          >
            <h3 class="title-generic mg-bottom-24 mg-top-8">
              Documentos anexados
            </h3>
            <div
              *ngFor="
                let attachment of boobleModalData?.orderAttachments;
                let i = index
              "
            >
              <div class="document-and-icon">
                <div id="document-name">
                  <img src="assets/image/clip-icon.svg" />

                  <p [title]="attachmentFileName(attachment?.fileName)">
                    {{ attachmentFileName(attachment?.fileName) }}
                  </p>

                  <!-- <img src="assets/image/view-icon.svg" /> -->
                </div>

                <div
                  class="d-flex gap-8 tappable"
                  (click)="downloadAttachment(attachment)"
                >
                  <span class="text-blue">Baixar</span>
                  <img src="assets/image/download-icon.svg" />
                </div>
              </div>
            </div>
          </div>

          <ng-container
            *ngIf="
              this.boobleModalData?.numeroDI ||
              this.boobleModalData?.protocoloDI
            "
          >
            <div class="box-order">
              <h4 class="mg-bottom-32 mg-top-8 title-generic">
                Informações da Declaração de Importação
              </h4>
              <div class="row">
                <div class="col-md-6">
                  <span class="p-text-grey">
                    Número da DI:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.numeroDI }}
                    </span></span
                  ><br />
                </div>
                <div class="col-md-6">
                  <span class="p-text-grey">
                    Protocolo da DI:&nbsp;
                    <span class="value"
                      >{{ this.boobleModalData?.protocoloDI }}
                    </span></span
                  ><br />
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="modal-footer-new" [style.justify-content]="'space-between'">
        <button
          class="stroked-red"
          (click)="cancelOrder(this.boobleModalData)"
          mat-stroked-button
        >
          Cancelar a ordem
        </button>

        <div class="d-flex gap-22">
          <button class="flat-red" (click)="repproveOrder()" mat-button>
            <mat-icon>close</mat-icon>

            <span> Reprovar </span>
          </button>

          <button class="flat-green" (click)="approveOrder()" mat-button>
            <mat-icon>check</mat-icon>
            <span> Aprovar </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
